import { I18nUtils } from '../../../../i18n/I18nUtils';
import { isDNIValid } from '../../../shared/utils/StringUtils';

export class WorkerFormValidator {

    static validate(values) {
        const {
            dni,
            name,
            lastName,
            agreement,
            outsource,
            contractorSchema,
        } = values;

        const errors = {};
        const emptyFieldError = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');

        if ( !dni ) errors.dni = emptyFieldError;
        if ( !name ) errors.name = emptyFieldError;
        if ( !lastName ) errors.lastName = emptyFieldError;
        if ( !agreement ) errors.agreement = emptyFieldError;
        if ( outsource.length === 0 ) errors.outsource = emptyFieldError;

        if ( dni && !isDNIValid(dni) ) errors.dni = I18nUtils.tr('TR_DNI_NO_VALIDO');

        if ( contractorSchema && contractorSchema.length !== 0 ) {
            if (!values.position || values.position === '') {
                errors.position = emptyFieldError;
            }
        }
        if (values.position && (!contractorSchema || contractorSchema.length === 0)) {
            errors.contractorSchema = emptyFieldError;
        }

        return errors;
    };

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/form/WorkerFormValidator.js